import { useMutation, useQueryClient } from 'react-query';
import { CustomerAgreementsApi } from '../CustomerAgreementsApi';
import { CustomerAgreementsQueryKey } from '../queryKeys';
import { refetchChangedQueries } from './refetchChangedQueries';
import { CustomerAgreement, CustomerAgreementInput } from '../types';

export type CreateCustomerAgreement = (input: CustomerAgreementInput) => Promise<CustomerAgreement>;

export function useCreateCustomerAgreementMutation(): CreateCustomerAgreement {
    const queryClient = useQueryClient();

    const mutation = useMutation<CustomerAgreement, unknown, CustomerAgreementInput>(
        (input) => CustomerAgreementsApi.createCustomerAgreement(input),
        {
            onSuccess: () => refetchChangedQueries(queryClient, [[CustomerAgreementsQueryKey]])
        }
    );

    return function createCustomerAgreement(input: CustomerAgreementInput) {
        return mutation.mutateAsync(input);
    };
}
